exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header-row[data-v-8518c5b0] {\n  color: #999;\n  font-size: 0.8em;\n}", ""]);

// exports
